import { analytics } from "controller/firebase"

export function LogEvent(event, params) {
    if (!process.env.NODE_ENV || process.env.NODE_ENV === "development") {
        console.log({ event, params })
            //analytics.logEvent(event, params)
    } else {
        analytics.logEvent(event, params)
    }
}